import { createMuiTheme } from "@material-ui/core/styles";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";
import { white } from "ansi-colors";
import label from "./whiteLabel";

const dark = label.darkColor;
const light = label.lightColor;

const breakpoints = createBreakpoints({});

export const theme = createMuiTheme({
  breakpoints,
  typography: {
    useNextVariants: true,
    fontFamily: ["Montserrat", "sans-serif"]
  },
  palette: {
    background: {
      default: light,
      secondary: white,
      paper: `whitesmoke`
    },
    primary: {
      main: dark
    },
    secondary: {
      main: light
    },
    error: {
      main: "rgb(255,0,0)"
    }
  },
  screen: {
    background: white,
    display: "flex",
    height: "100vh"
  },
  overrides: {
    MuiCard: {
      root: {
        // minHeight: "90vh",
        justifySelf: "center",
        background: white
      }
    },
    MuiInputBase: {
      root: {},
      input: {
        fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
        "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
        sans-serif;`
      }
    },
    MuiFormControl: {
      root: {
        marginTop: "2rem",
        marginBottom: "1rem"
      }
    },
    MuiButton: {
      text: {
        background: `linear-gradient(0.91turn, ${light} 1%, ${dark} 99%)`,
        color: "white",
        textTransform: "none",
        // fontSize: "1rem",
        fontWeight: 600
      },
      outlined: {
        border: `1px solid ${light}`,
        color: light,
        textTransform: "none",
        fontWeight: 600
      }
    },
    MuiAppBar: {
      root: {
        height: 60,
        padding: 10
      }
    },
    MuiBottomNavigation: {
      root: {
        flexDirection: "row",
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        boxShadow: "1px 1px 1px 1px #ccc"
      }
    },
    MuiBottomNavigationAction: {
      root: {
        [breakpoints.down("xs")]: {
          minWidth: 0
        }
      }
    },
    MuiDialog: {
      root: {
        left: 0,
        minWidth: 0
      },
      paper: {
        [breakpoints.down(365)]: {
          margin: 10
          // minHeight: "400px"
        }
      }
    },
    MuiTabs: {
      root: {
        width: "100%"
      },
      indicator: {
        display: "none"
      },
      centered: {
        alignItems: "center",
        justifyContent: "center"
      }
    },
    MuiTab: {
      root: {
        position: "relative",
        display: "block",
        textAlign: "center",
        transition: "all .5s",
        padding: "10px 24px",
        minWidth: "170px !important",
        color: "#555555",
        height: "auto",
        opacity: "1",
        float: "none",
        backgroundColor: "#eee",
        border: "1px solid #ccc",
        "& + button": {
          margin: "10px 0"
        },
        "&$selected": {
          "&, &:hover": {
            color: "#FFFFFF",
            backgroundColor: dark
          }
        },
        "&:first-of-type": {
          borderTopLeftRadius: "2px",
          borderBottomLeftRadius: "2px",
          borderRight: "none"
        },
        "&:last-of-type": {
          borderTopRightRadius: "2px",
          borderBottomRightRadius: "2px"
        }
      },
      labelContainer: {
        padding: "0!important",
        color: "inherit"
      },
      label: {
        lineHeight: "24px",
        textTransform: "uppercase",
        fontSize: "14px",
        fontWeight: 600,
        position: "relative",
        display: "block",
        color: "inherit"
      }
    },
    MuiBadge: {
      badge: {
        zIndex: 0
      }
    }
  }
});
